import { observer } from 'mobx-react-lite'
import { useStores } from 'models/root-store'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from 'routes'
import { useAuthState } from 'services'
import { useRedButtonConfigSync } from 'services/redbutton/use-red-button-config-sync'
import { LoginPage } from 'pages/login'
import { MainLayout } from 'layouts'

const App = observer(() => {
  const {
    livesStore: { fromRedirect },
  } = useStores()

  useRedButtonConfigSync()

  const { user } = useAuthState()
  if (!fromRedirect && !user) {
    return <LoginPage />
  }

  return (
    <MainLayout>
      <Router>
        <Routes />
      </Router>
    </MainLayout>
  )
})

export default App
